import image from "../images/productimage/car (1).jpg";
const data = [
  {
    client: "Alice Johnson",
    _id: 1,
    image: image,
    phone: "0712345001",
    address: "123 Elm St, Colombo",
    category: "Car",
  },
  
  {
    client: "Bob Smith",

    _id: 2,
    image: image,
    phone: "0712345002",
    address: "456 Maple Ave, Colombo",
    category: "Bike",
  },
  {
    client: "Charlie Brown",
    _id: 3,
    image: image,
    phone: "0712345003",
    address: "789 Oak Dr, Colombo",
    category: "Car",
  },
  {
    client: "Diana Prince",

    _id: 4,
    image: image,
    phone: "0712345004",
    address: "135 Pine Rd, Colombo",
    category: "Bike",
  },
  {
    client: "Ethan Hunt",

    _id: 5,
    image: image,
    phone: "0712345005",
    address: "246 Birch Blvd, Colombo",
    category: "Car",
  },
  {
    client: "Fiona Gallagher",
    _id: 6,
    image: image,
    phone: "0712345006",
    address: "357 Cedar Ct, Colombo",
    category: "Bike",
  },
  {
    client: "George Washingt",
    _id: 7,
    image: image,
    phone: "0712345007",
    address: "468 Willow Way, Colombo",
    category: "Car",
  },
  {
    client: "Hannah Montana",
    _id: 8,
    image: image,
    phone: "0712345008",
    address: "579 Spruce St, Colombo",
    category: "Bike",
  },
  {
    client: "Isaac Asimov",

    _id: 9,
    image: image,
    phone: "0712345009",
    address: "680 Cherry Ln, Colombo",
    category: "Car",
  },
  {
    client: "Jack Daniels",
    _id: 10,
    image: image,
    phone: "0712345010",
    address: "791 Birchwood Dr, Colombo",
    category: "Bike",
  },
];

export default data;
